import styled from '@emotion/styled'
import { Stack } from '@mui/material'

export const TeamControlsContainer = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  width: 100%;
  background-color: white;
  margin-top: 16px;
`
